/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, Dispatch, SetStateAction } from 'react'
import { AxiosError } from 'axios'
import { useMutation } from 'react-query'
import toast from 'react-hot-toast'
import { captureEvent } from '@sentry/react'

//contexts
import AuthContext from 'context/AuthContext'
//constants
import { ANALYTICS_EVENT } from 'constants/index'
//services
import { dailyStreakAdWatched } from 'services/dailyStreak'
//utils
import { sendGA4Event } from 'utils/utils'

const useMutationAdWatched = (
  setShowClaimPopup: Dispatch<SetStateAction<boolean>>,
  setShowBackgroundPigsAnimation: Dispatch<SetStateAction<boolean>>
) => {
  const { user, updateUserData } = useContext(AuthContext) as any
  const { mutate: adWatchedMutate, isLoading: isLoadingAdWathced } = useMutation(
    (internalAdId?: string) => {
      sendGA4Event(ANALYTICS_EVENT.DAILY_AD_STREAK_CREDIT_REQUESTED, {
        internal_ad_id: internalAdId || 'unknown',
      })
      return dailyStreakAdWatched(internalAdId)
    },
    {
      onSuccess: async (data, internalAdId) => {
        const updatedUser: any = { ...data.data }
        updatedUser.piggyBanks = user.piggyBanks
        updateUserData(updatedUser)
        setShowBackgroundPigsAnimation(false)
        sendGA4Event(ANALYTICS_EVENT.DAILY_AD_STREAK_CLAIM_POPUP_SHOWN, {
          internal_ad_id: internalAdId || 'unknown',
        })
        setShowClaimPopup(true)
      },
      onError: (error, internalAdId) => {
        captureEvent({
          message: 'Daily streak credit request failed',
          level: 'error',
          extra: {
            internal_ad_id: internalAdId || 'unknown',
            status: (error as AxiosError)?.response?.status,
            message: ((error as AxiosError)?.response?.data as Error)?.message,
          },
        })
        toast.error(
          ((error as AxiosError)?.response?.data as Error).message || 'Something went wrong!'
        )
      },
    }
  )
  return { adWatchedMutate, isLoadingAdWathced }
}

export default useMutationAdWatched
